import { Component, ComponentInterface, EventEmitter, h, Host, JSX, Listen, Prop, Event } from '@stencil/core';
import { Keys } from '../../shared/keys';

/**
 * @slot - `wb-header-fly-in` elements placed within the container
 */
@Component({
  tag: 'wb-header-fly-in-container',
  styleUrl: 'header-fly-in-container.scss',
  shadow: true,
})
export class HeaderFlyInContainerComponent implements ComponentInterface {
  /** if present the fly in container is visible */
  @Prop({ reflect: true })
  public open: boolean = false;

  /** emitted when the `ESC` key was clicked */
  @Event()
  public wbclose!: EventEmitter;

  @Listen('keyup', { target: 'window' })
  public onKeyUp(e: KeyboardEvent): void {
    if (e.key === Keys.ESC) {
      this.wbclose.emit();
    }
  }

  public render(): JSX.Element {
    return (
      <Host class="wb-header-fly-in-container">
        <div class="close-layer"></div>
        <div class="inner">
          <slot />
        </div>
      </Host>
    );
  }
}
